import React from "react"
import PropTypes from "prop-types"
import dateTimeWithTimeFormat from '../utils/dateTimeWithTimeFormat'
import { isConvoUnread, normalizeId } from './convoUnread'

function truncatePreview(text, maxLength = 80) {
  if (!text || text.length <= maxLength) {
    return text
  }

  return `${text.slice(0, maxLength).trim()}…`
}

class ConvoTeaserItem extends React.Component {
  otherUserImg() {
    const { convo, currentUser, missingImg } = this.props
    const otherUser = normalizeId(currentUser.id) === normalizeId(convo.sender.id)
      ? convo.recipient
      : convo.sender
    return otherUser.avatar_url === "medium/missing.png" ? missingImg : otherUser.avatar_url
  }

  otherUserName() {
    const { convo, currentUser } = this.props
    return normalizeId(currentUser.id) === normalizeId(convo.sender.id)
      ? convo.recipient.preferred_name
      : convo.sender.preferred_name
  }

  render() {
    const { convo, currentUser, openConvo } = this.props
    const unread = isConvoUnread(convo, currentUser)

    return (
      <button
        type="button"
        className={`convoListItem${unread ? ' convoListItem--unread' : ''}`}
        onClick={() => openConvo(convo.id)}
        aria-label={unread ? `Unread conversation with ${this.otherUserName()}` : undefined}
      >
        <div className="convoListItem__avatarWrap">
          <img
            src={this.otherUserImg()}
            className="convoListItem__avatar"
            alt=""
          />
        </div>
        <div className="convoListItem__body">
          <div className="convoListItem__topRow">
            <h3 className="convoListItem__name">{this.otherUserName()}</h3>
            <div className="convoListItem__meta">
              <time className="convoListItem__time" dateTime={convo.last_msg.created_at}>
                {dateTimeWithTimeFormat(convo.last_msg.created_at)}
              </time>
              {unread && (
                <span className="convoListItem__unreadTag">Unread</span>
              )}
            </div>
          </div>
          <p className="convoListItem__preview">
            {truncatePreview(convo.last_msg.body)}
          </p>
        </div>
      </button>
    )
  }
}

ConvoTeaserItem.propTypes = {
  convo: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  missingImg: PropTypes.string.isRequired,
  openConvo: PropTypes.func.isRequired,
}

export default ConvoTeaserItem
